import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import useBreadcrumb from "../../hooks/useBreadcrumb";
import { shouldRedirectBackToHome } from "../../Utils/breadcrumbConfig";

const BackSections = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getPreviousRoute } = useBreadcrumb();

  const isOrderConfirmationPage = location.pathname === "/order-confirmation";
  const isOrderFailure =
    isOrderConfirmationPage &&
    location?.state?.orderStatus?.toLowerCase() === "failed";
  const paymentFailedPage = location.pathname === "/payment-failed";

  const handleClick = () => {
    const prevRoute = getPreviousRoute();
    if (prevRoute) {
      navigate(shouldRedirectBackToHome(prevRoute) ? "/" : prevRoute);
    } else {
      navigate(-1);
    }
  };

  const translation = getTranslationData();

  return (
    <section
      className={`desktop-hide backButton backButtonsection ${
        isOrderFailure ? "hide-order-failed-header" : ""
      }`}
    >
      <div className="back back_section_top">
        {!isOrderConfirmationPage && !paymentFailedPage && (
          <div className="backtext" onClick={handleClick}>
            <i className="fa-solid fa-chevron-left clr-black-blk"></i>
            <span className="fw-bold">{translation?.back}</span>
          </div>
        )}
        <div className="heading_title">
          {location.pathname === "/orders" ? (
            <div className="text-center fw-bold">{translation?.myOrders}</div>
          ) : location.pathname === "/card" ? (
            <div className="text-center fw-bold">{translation?.checkout}</div>
          ) : location.pathname === "/cart" ? (
            <div className="text-center fw-bold">{translation?.cartTitle}</div>
          ) : location.pathname === "/order-detail" ? (
            <div className="text-center fw-bold">
              {translation?.orderDetails}
            </div>
          ) : location.pathname === "/payment-failed" ? (
            <div className="text-center fw-bold">
              {translation?.paymentFailed}
            </div>
          ) : location.pathname === "/myprofile" ? (
            <div className="text-center fw-bold">{translation?.myAccount}</div>
          ) : isOrderConfirmationPage ? (
            <div className="text-center fw-bold">
              {isOrderFailure
                ? translation?.order_failed
                : translation?.orderConfirmation}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </section>
  );
};

export default BackSections;
